<template>
<div class="am__container">
    <p class="text-muted">Datos del Ejecutivo de Ventas</p>

    <div v-if="!showAccountManager" class="alert text-info text-left">
        <i class="fas fa fa-info-circle mr2"></i>
        Debe guardar los cambios para poder agregar un Ejecutivo de Ventas.
    </div>

    <div v-else class="row">
        <div v-if="(!records || records.length === 0) && !editMode && !loading" class="text-left p-3">
            <p>No hay Ejecutivo de Venta</p>
            <button v-if="actions.post" @click="addNewAccountManager()" type="button" class="btn btn-success">Agregar nuevo</button>
        </div>
        <div class="col-sm-12" v-if="!editMode">
            <MySpinner :loading="loading"/>
            <div class="p-1" v-for="am of records" :key="am.identifier">
                <template v-if="am.value">
                    <div class="row">
                        <div class="col">
                            <p class="mb-0"><small class="text-muted">Nombre</small><br> {{am.value.name}}</p>
                        </div>
                        <div class="col">
                            <p class="mb-0"><small class="text-muted">Email</small><br> {{am.value.email}}</p>
                        </div>
                        <p class="mb-0"><small class="text-muted">Teléfono</small><br> {{am.value.phoneNumber}}</p>
                    </div>
                    <div class="mt-3">
                        <button v-if="actions.put" type="button" :disabled="!am.identifier || loading" class="btn btn-info px-4" @click="editAccountManager(am.identifier)" >Editar</button>
                        <button v-if="actions.delete" type="button" :disabled="!am.identifier || loading" class="btn btn-link text-danger px-4" @click="deleteAccountManager(am.identifier)" >Borrar</button>
                    </div>
                </template>
            </div>
        </div>
        <div class="col-sm-12" v-if="editMode && accountManager">
            <template v-if="accountManager.value">

                <div class="form-group mb-1">
                    <label class="text-muted small">Nombre</label>
                    <input v-model="accountManager.value.name" :class="{ 'noedit': !editMode }" :disabled="loading || !editMode" type="text" class="form-control" placeholder="Nombre del ejecutivo">
                    <span class="text-danger small" v-if="accountManager.value.name.trim().length > 0 && !isName">Nombre inválido</span>
                </div>

                <div class="form-group mb-1">
                    <label class="text-muted small">Email</label>
                    <input v-model="accountManager.value.email" :class="{ 'noedit': !editMode }" :disabled="loading || !editMode" type="email" class="form-control" placeholder="Ingresa un email válido">
                    <span class="text-danger small" v-if="accountManager.value.email.trim().length > 3 && !isEmail">Email inválido</span>
                </div>

                <div class="form-group mb-1">
                    <label class="text-muted small">Teléfono Móvil</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">+56</span>
                        </div>
                        <input v-model="accountManager.value.phoneNumber" maxlength="9" :class="{ 'noedit': !editMode }" :disabled="loading || !editMode" type="text" class="form-control" placeholder="Teléfono de contacto">
                    </div>
                    <span class="text-danger small" v-if="accountManager.value.phoneNumber.trim().length > 0 && !isPhone">Teléfono inválido</span>
                </div>

                <div class="text-right">
                    <hr class="my-3">
                    <button :disabled="loading" @click="toggleEdit" class="btn btn-link">Cerrar</button>
                    <button :disabled="!isValidForm || loading" @click="handleSetAccountManager" 
                    type="button" class="btn btn-info"><i class="fa fa-save"></i> {{ loading ? 'Cargando...' : 'Guardar'}}</button>
                </div>

            </template>

            <div v-else class="alert alert-danger p-2"><strong>Error en datos del Ejecutivo</strong><br> Los datos no están correctamente formados.</div>

        </div>
    </div>
</div>
</template>
<script>
import Auth from "@/helpers/middleware";
import sysMsgs from "@/helpers/system.message";
import validation from "@/helpers/validations";

class AccountManagerValue {
    constructor() {
        this.name = "";
        this.email = "";
        this.phoneNumber = "";
    }
}

class AccountManager {
    constructor() {
        this.identifier = null
        this.value = new AccountManagerValue()
    }
}

import entityServices from '@/services/entity.services.js'
export default {
    name:"AccountManagerForm",
    props: ['dealerIdentifier', 'isNetsuiteActive'],
    data() {
        return {
            actions: Auth.getActions(this.$route.name),
            editMode: false,
            records: [],
            accountManager: new AccountManager(),
            loading: false,
            prevState: null,
            showAccountManager: false,
        }
    },
    computed: {
        isPhone() {
            const { value } = this.accountManager;
            return value ? validation.isNumeric(value.phoneNumber) : false;
        },
        isEmail() {
            const { value } = this.accountManager;
            return value ? validation.isEmail(value.email) : false;
        },
        isName() {
            const { value } = this.accountManager;
            return value ? value.name.trim().length > 1 : false;
        },
        isValidForm() {
            return this.isName && this.isEmail && this.isPhone;
        }
    },
    watch: {
        dealerIdentifier: {
            deep: true,
            handler(data) {
                if (data) {
                    this.editMode = false;
                    this.getEntityProperties();
                }
            }
        }
    },
    created() {
        if(this.dealerIdentifier)
            this.getEntityProperties();
    },
    methods: {
        toggleEdit() {
            this.editMode = false;
            this.records = this.prevState;
        },
        getEntityProperties() {
            this.showAccountManager = true;
            this.loading = true;
            entityServices.getEntityProperties(this.dealerIdentifier, 'ACCOUNTMANAGER').then(data => {
                this.records = data;
                this.prevState = data;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                sysMsgs.getResponseMessage(error.response)
            });
        },
        editAccountManager(identifier) {
            this.editMode = true;
            this.accountManager = this.records.find(item => item.identifier === identifier);
            this.prevState = this.cleanSource(this.records);
        },
        addNewAccountManager() {
            this.editMode = true;
            this.accountManager = new AccountManager();
        },
        handleSetAccountManager() {
            this.accountManager.identifier === null ? this.createAccountManager() : this.updateAccountManager();
        },
        createAccountManager() {
            const payload = {
                type: "ACCOUNTMANAGER",
                ...this.accountManager
            }

            this.loading = true;
            entityServices.setEntityProperties(this.dealerIdentifier, payload).then(() => {
                this.editMode = false;
                this.loading = false;
                this.getEntityProperties();
                this.accountManager = new AccountManager();
                sysMsgs.getMessage("Datos agregados exitosamente.", "success");
            }).catch(error => {
                this.loading = false;
                sysMsgs.getResponseMessage(error.response)
            });

        },
        updateAccountManager() {
            const payload = {
                type: "ACCOUNTMANAGER",
                value: this.accountManager.value
            }

             entityServices.setEntityProperties(this.dealerIdentifier, payload, this.accountManager.identifier).then(() => {
                this.editMode = false;
                this.getEntityProperties();
                this.accountManager = new AccountManager();
                sysMsgs.getMessage("Datos actualizados exitosamente.", "success");
            }).catch(error => sysMsgs.getResponseMessage(error.response));
        },
        deleteAccountManager(propertyIdentifier) {
            sysMsgs.getConfirm("¿Está seguro que desea eliminar los datos?", "warning").then(result => {
                if(result.value) {
                    this.loading = true;
                    entityServices.removeEntityProperties(this.dealerIdentifier,  propertyIdentifier).then(() => {
                        this.loading = false;
                        this.getEntityProperties();
                    }).catch(error => {
                        this.loading = false;
                        sysMsgs.getResponseMessage(error.response)
                    });
                }
            });
        },
        cleanSource(source) {
            return JSON.parse(JSON.stringify(source));
        }
    }
}
</script>
<style lang="scss" scoped>

.form-control {
    &.noedit {
        cursor: auto;
        background: #fff;
        border: none!important;
        box-shadow: none!important;
        outline: none;
        pointer-events: none;
    }
}
.am {
    &__container {
        max-width: 400px;
        min-height: 300px;
    }
}
</style>